import { Component, ElementRef, forwardRef, Input, OnDestroy, Renderer2, inject } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'vb-style-editor',
  templateUrl: './style-editor.component.html',
  styleUrls: ['./style-editor.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StyleEditorComponent),
      multi: true
    }
  ],
  standalone: false  //NOSONAR
})
export class StyleEditorComponent implements OnDestroy {
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);

  @Input() element: any;
  private modelValue: any;
  private onChange: (m: any) => void;
  private onTouched: (m: any) => void;
  disabled = false;
  editorOptions = { theme: 'vs-light', language: 'css' };
  value: any;
  editor: any = null;

  get model() {
    return this.modelValue;
  }

  writeValue(value: any): void {
    this.setValue(value);
    this.modelValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  set(value: any) {
    this.modelValue = value;
    this.onChange(this.modelValue);
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
    this.disabled = isDisabled;
  }

  setValue(value) {
    if (!value) {
      this.value = '';
    }
    this.editorOptions = {
      theme: 'vs-light', // 'vs-dark',
      language: 'css'
    };
  }

  editorInit(editor: any) {
    this.editor = editor;
    this.editor.onDidChangeModelContent((event: any) => {
      this.modelValue = this.value;
      this.onChange(this.modelValue);
    });
  }

  ngOnDestroy(): void {
    if ($(this.elementRef.nativeElement)) {
      $(this.elementRef.nativeElement).remove();
    }
  }
}
